import { render, staticRenderFns } from "./Distributor_stats.vue?vue&type=template&id=a40e0790&scoped=true&lang=pug&"
import script from "./Distributor_stats.vue?vue&type=script&lang=coffee&"
export * from "./Distributor_stats.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40e0790",
  null
  
)

export default component.exports